<div class="filter float-right" *ngIf="miniCloseButton && !show" [class.positionRight]="positionRight">
  <button class="btn btn-sm " (click)="show=!show;close()"><i
    class="fa fa-filter"></i></button>
</div>

<div
  #contentRef
  class="filter cm-content-box box-primary"  [class.mb-0]="positionRight"  [class.mt-3]="positionRight"
  [@accordion]="show ? 'open' : 'closed'"
>
  <button class="btn btn-sm mini-close" *ngIf="miniCloseButton" (click)="show=!show;close()"><i
    class="fa fa-close"></i></button>
  <div class="content-title" *ngIf="header">
    <div class="cpa">

      <i *ngIf="showIcon" class="fa-sharp fa-solid fa-filter me-2"></i>
      <span *ngIf="placeholder"> {{ placeholder }}</span>
    </div>
    <div class="tools" *ngIf="closeButton">
      <a (click)="close()" class="btn btn-default btn-icon-md">
        <i class="fa fa-close"></i>
      </a>
    </div>
  </div>

  <div class="cm-content-body form excerpt" *ngIf="show">
    <div class="card-body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
